module.exports = __webpack_public_path__ + "img/18.7f843ef6.jpg";